import Header from "./components/Header.tsx";
import logo from "./assets/images/logo.png";
import { Outlet } from "react-router-dom";
import Footer from "./components/Footer.tsx";
import "./App.css";

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

function App() {
var localData = localStorage.getItem("lang");
var lang = "fr";
if (localData != null) {
    lang = JSON.parse(localData);
}

const [currentLang, setLang] = useState(lang);
const [t, i18n] = useTranslation("global");

useEffect(() => {
    document.documentElement.lang = currentLang;
}, [currentLang]);

const onSelectLang = function onSelectedLang(lang: string) {
    localStorage.setItem("lang", JSON.stringify(lang));
    i18n.changeLanguage(lang);
    setLang(lang);
};

  return (
    <>
      <Header
        essai={t("home.first-section-free-trial")}
        login={t("header.login")}
        currentLang={currentLang}
        onSelectLang={onSelectLang}
        image={logo}
        registration={t("header.registration")}
        menu={[
          {
            name: t("header.home"),
            to: "/",
          },
          {
            name: t("header.infos"),
            to: "infos",
          },
          {
            name: t("header.pricing"),
            to: "pricing",
          },

          {
            name: t("header.contact"),
            to: "contact",
          },
          // {
          //   name: t("footer.resources"),
          //   to: "resources",
          // },
        ]}
        siteName="ISOeVAL"
        btnName={""}
        onBtnClick={() => console.log("btn click")}
      />
      <Outlet />
      <Footer
        menu={[
          {
            name: t("header.home"),
            to: "/",
          },
          {
            name: t("header.infos"),
            to: "infos",
          },
          {
            name: t("header.pricing"),
            to: "pricing",
          },
          {
            name: t("header.contact"),
            to: "contact",
          }
        ]}
      />
    </>
  );
}

export default App;
